/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React from "react";

import Checkbox from "../NewCheckbox";

function NewMultiSelect({
    selected,
    items,
    onChange,
    itemValue = "id",
    itemText = "name",
}) {
    const onCheckboxChange = ({ target }) => {
        //Use Set to remove duplicates by default.
        let collection = new Set(selected);
        target.value
            ? collection.add(target.name.toString())
            : collection.delete(target.name.toString());
        onChange([...collection]);
    };

    return (
        <>
            {items.map((item) => (
                <div key={item[itemValue]}>
                    <Checkbox
                        name={item[itemValue]}
                        checked={selected.includes(item[itemValue])}
                        label={item[itemText]}
                        onChange={onCheckboxChange}
                        withField
                    />
                </div>
            ))}
        </>
    );
}

export default NewMultiSelect;
